import type { SearchResultItemStory } from '../../../atoms/searchResults.js'
import { ResultCollection } from './ResultCollection.js'

type Props = {
  items: SearchResultItemStory[]
  onCloseSearchDialog: () => void
  navigationDisabled?: boolean
  activeItemId?: string
}

export function FavoriteResults(props: Props) {
  const { onCloseSearchDialog, navigationDisabled, items, activeItemId } = props

  return (
    <ResultCollection
      activeItemId={activeItemId}
      navigationDisabled={navigationDisabled}
      noResults="Favorite results will appear here."
      onCloseSearchDialog={onCloseSearchDialog}
      results={items}
      title="Favorites"
      variant="favorite"
    />
  )
}
